export const pdfAction = (fileId, pdfDisplay) => {
    return{
        type: 'changePDF',
        pdf: {
            id: fileId,
            display: pdfDisplay
        }
    }
}